import { inject, injectable } from 'inversify'
import {
  FetchUserOffersUseCaseInput,
  FetchUserOffersUseCaseOutput,
  IAppErrorFactory,
  IFetchUserOffersUseCase,
  IOffersService,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class FetchUserOffersInteractor implements IFetchUserOffersUseCase {
  @inject(symbols.IOffersService) private offerService: IOffersService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchUserOffersUseCaseInput): Promise<FetchUserOffersUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      const { offers, hasNextPage } = await this.offerService.fetchUserOffers(input)

      output.offers = offers
      output.hasNextPage = hasNextPage
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchUserOffersUseCaseOutput {
    return {
      offers: [],
      hasNextPage: true,
      error: null,
    }
  }
}
